export const DASHBOARD_MODES = {
  GESTION: "gestion",
  ORG: "org",
  MINE: "mine",
};

export const DASHBOARD_MODE_STORAGE_KEY = "revaDashboardMode";

export function availableDashboardModes({ isRevaAdmin, hasGestionAccess, hasOrganizations }) {
  const extra = [];
  if (hasGestionAccess) extra.push(DASHBOARD_MODES.GESTION);
  if (hasOrganizations) extra.push(DASHBOARD_MODES.ORG);
  if (isRevaAdmin) {
    return [DASHBOARD_MODES.MINE, ...extra];
  }
  return [...extra, DASHBOARD_MODES.MINE];
}

export function resolveDashboardMode({ queryMode, storedMode, available }) {
  if (queryMode && available.includes(queryMode)) return queryMode;
  if (storedMode && available.includes(storedMode)) return storedMode;
  return available[0] || DASHBOARD_MODES.MINE;
}
